import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { PriorityEntityLikePicker } from '../../../../components/entity-picker/PriorityEntityLikePicker';
import { FilterCard } from '../filter-card/FilterCard';

type Props = {
  title: string;
  value: { id: number; name: string }[] | null;
  onChange: (value: { id: number; name: string }[]) => void;
  expanded: boolean;
  onExpandedChange: (val: boolean) => void;
};

export const TicketPriorityFilterCard: React.FC<Props> = (props) => {
  const { title, value, onChange, expanded, onExpandedChange } = props;

  const { t } = useTranslation();

  const filterValueText: string = useMemo(() => {
    if (!value?.length) return null;
    if (value.length === 1) return value[0].name;
    return t('COMMON.CHOSEN', { count: value.length });
  }, [value, t]);

  return (
    <FilterCard
      title={title}
      filterValue={filterValueText}
      filterValueSet={!!filterValueText}
      expanded={expanded}
      onExpandedChange={onExpandedChange}
      onValueDelete={() => {
        onChange([]);
      }}
    >
      <PriorityEntityLikePicker
        multiple={true}
        value={value}
        onChange={onChange}
      />
    </FilterCard>
  );
};
